module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./EquityShareView.js"));
	}, "EquityShareView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EquityShareView!./src/pages/Promote/Equity/EquityShare/EquityShareView.js
// module id = 1642
// module chunks = 418